export enum IconKeys {
  ROUNDED_ARROW_RIGHT,
  ROUNDED_ARROW_LEFT,
  CAR,
  GEOFENCE,
  HOME,
  LIGHTNING,
  LISTBOX,
  LOGO,
  LOGO_LIGHT,
  PHOTO,
  PLUS,
  QUESTION,
  SETTINGS,
  SUITCASE,
  USER,
  USERS,
  USER_MANAGEMENT,
  VIDEO,
  ADD_VIDEO,
  ARROW_RIGHT,
  TIME,
  DATE,
  TRUCK,
  LOCATION,
  DETAILS,
  PULSE,
  DISTANCE,
  ALERT,
  ALERT_LIGHT,
  ALERT_CIRCLE,
  ALERT_CIRCLE_LIGHT,
  ARROW_DOWN,
  ARROW_DOWN_LIGHT,
  SPARK_ALERT,
  SPARK_ALERT_LIGHT,
  ROADWORK,
  WEATHER,
  CLOCK,
  CLOCK_HISTORY,
  NOTES,
  BOOKMARKS,
  BELL,
  ANNOUNCEMENT,
  EXTEND,
  EXTEND_LIGHT,
  SEARCH,
  SEARCH_LIGHT,
  SEARCH_SMALL,
  LIST,
  CAR_OUTLINED,
  PHOTO_OUTLINED,
  SPARK_OUTLINED,
  EVENT,
  RISK_LEVEL,
  ASSIGNED_STATUS,
  CHEVRON_RIGHT,
  CHEVRON_RIGHT_LIGHT,
  SETTINGS_OUTLINED,
  FLAG_OUTLINED,
  MOON_OUTLINED,
  LOG_OUT,
  VIEW_ALL,
  VIEW_ALL_LIGHT,
  MOVE,
  CAR_HATCHBACK,
  CLIPBOARD_PLUS,
  ARROW_LEFT,
  ARROW_LEFT_LIGHT,
  CLOSE,
  CLOSE_LIGHT,
  EYE_OFF,
  TRIPS,
  DELETE,
  DELETE_USER_DATA,
  LINK,
  ADD_NOTE,
  EDIT_NOTE,
  EDIT,
  DOCUMENT_AWARD,
  PORTRAIT,
  SUMMARIZE,
  SYNCED,
  SYNC_PENDING,
  SYNC_FAILED,
  SYNC_NOTFOUND,
  SYNCED_GLOBAL,
  SYNCED_GLOBAL_LIGHT,
  SYNC_PENDING_GLOBAL,
  SYNC_PENDING_GLOBAL_LIGHT,
  RECORD,
  MERGED_TRIP,
}
